import InfoboxContainer from "../../components/infoBox/InfoboxContainer";
import TrackingSourcesTable from "../../components/tables/trackingSourcesTable";
import React from "react";
import FormSubmissionTable from "../../components/tables/fsTable";

const FormSubmission = () => (
    <>
        <FormSubmissionTable />
    </>
);

export default FormSubmission;